import styles from './EmptyState.module.scss';

export const EmptyState = () => {
  return (
    <div>
      <h5 className={styles.emptyStateTitle}>No files uploaded</h5>
      <p className={styles.emptyStateDescription}>Upload your documents, photos etc...</p>
    </div>
  );
};
